import { createActions } from '../utils/actions';

const { actions: bulkPhotoEditor } = createActions('bulkPhotoEditor')
  .addAsync('addBackground')
  .add('close')
  .addAsync('getPhotos')
  .addAsync('removeBackground')
  .add('restoreOriginals')
  .addAsync('save')
  .add('selectAll')
  .add('setLoading')
  .add('startEditing')
  .add('togglePhoto');

export default bulkPhotoEditor;
